import type { DashMiddleware, DashStore, DashNext } from '@makemydeal/dr-shared-store';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { changeDealMode } from '../actions/dealModeActionCreators';
import { DealMode } from '../types/dealModeEnum';
import type { BaggageEntry } from '@makemydeal/dr-dash-bff-types';
import { setBreakdownStatus } from '../actions/baseDealActionCreators';
import * as dealModeSelectors from '../selectors/dealModeSelectors';

const { INIT_PENCIL_SUCCESS } = initActionTypes;

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);
    const state = store.getState();
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            const { baggage = [] } = action.payload;
            const mvBaggage = baggage.find(({ name }: BaggageEntry) => name === 'deal360.mvDealState');

            if (!mvBaggage || !mvBaggage.value || !mvBaggage.value.content) {
                //IF baggage not found update the breakdown status based on the current deal mode
                const isDealCentralExperience = dealerSelectors.isDealCentralExperience(state);
                const isFnIDealMode = dealModeSelectors.isFnIDealMode(state);
                if (isDealCentralExperience) {
                    store.dispatch(setBreakdownStatus(!isFnIDealMode));
                }
                break;
            }

            const dealModeFromBaggage =
                mvBaggage.value.content.dealMode === DealMode.fiMode ? DealMode.fiMode : DealMode.deskingMode;
            const isBreakdownOpen = mvBaggage.value.content.breakdownState === 'open';
            store.dispatch(setBreakdownStatus(isBreakdownOpen));
            store.dispatch(changeDealMode(dealModeFromBaggage));
            break;
        }
        default:
            break;
    }
};
